export default {
  entityValueToText: (state) => ({ entityType, entityValues, entityReturnType = 'Object' }) => {
    if (entityValues === null || state[entityType] === undefined) return null;

    const values = Array.isArray(entityValues) ? entityValues : [entityValues];

    const returner = values.map((value) => {
      return state[entityType].find((entity) => entity.value === value);
    });

    if (returner.length === 1 && entityReturnType !== 'Array') {
      return returner[0];
    }

    return returner;
  },
  getReviewCompanyName: (state) => (compId) => {
    return state.companies.find((company) => company.value === compId);
  },
  getCdnImagePath: (state) => (imagePath) => {
    return `${state.site.cdnUrl}${imagePath}`;
  },
};
